import React, { useEffect, useState } from "react";
import "./Category.css";
import AllTicketsHeader from "../AllTickets/AllTicketsHeader";
import SideBar from "../SideBar/SideBar";
import axiosApiInstance from "../axios";
import DataTable from "react-data-table-component";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert, LinearProgress,Switch } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CAlertBox from '../CAlertBox/CAlertBox';


const Category = () => {
  const [category, setCategory] = useState([]);
  const [categorySearch, setCategorySearch] = useState([]);
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [openDeleteMssg, setOpenDeleteMssg] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [idEdit, setIdEdit] = useState([]);
  const [editName, setEditName] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [openUpdateMssg, setOpenUpdateMssg] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [checked, setChecked] = useState(true);
  const [perPage, setPerPage] = useState(10);
  const [errMessage, setErrorMessage] = useState(null);
  const [errMessageEdit, setErrorMessageEdit] = useState(null);
  useEffect(() => {
    if(!checked){
      axiosApiInstance
      .get(`/category?isactive=${checked}`)
      .then((res) => {
        setCategory(res.data.data);
        setCategorySearch(res.data.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
    }
    else{
      axiosApiInstance
      .get(`/category?isactive=${checked}`)
      .then((res) => {
        setCategory(res.data.data);
        setCategorySearch(res.data.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));

    }
    
  }, [open, isDelete, isOpenEdit,checked]);
  
  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      width: "70px",
      sortable: true,
    },
    {
      name: "Category",
      selector: (row) => row.name,
      justifyContent: 'end',
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    checked ? 
    {name: "Action",
    cell: (row) => (
      <>
        <ModeEditIcon onClick={() => handleEditClick(row)} />
        <p className="seperation-field">  </p>
        <DeleteOutlineIcon onClick={() => handleDeleteClick(row.id)} />
      </>
    ),
    tesxtAlign: 'end',
    } : 
    {name: "Action",
    cell: (row) => (
      <>
        <ModeEditIcon onClick={() => handleEditClick(row)} />
      </>
    ),
    tesxtAlign: 'end',
    }  
    
  ];

  useEffect(() => {
    const result = category.filter((catg) => {
      return catg?.name?.toLowerCase().match(searchTerm.toLowerCase());
    });
    setCategorySearch(result);
  }, [searchTerm]);

  useEffect(() => {
    if(name !== '' && description != ''){
      setErrorMessage(null);
    }

    if(editName !== '' && editDescription != ''){
      setErrorMessageEdit(null);
    }
  }, [name, description, editName, editDescription]);

  const handleDeleteClick = (id) => {
    setId(id);
    setIsDelete(true);
  };

  const handleClickOpen = () => {
    setName('');
    setDescription('');
    setErrorMessage(null)
    setOpen(true);
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteClose = () => {
    setIsDelete(false);
  };

  const handleEditClick = (id) => {
    setIdEdit(id);
    setEditName(id.name);
    setEditDescription(id.description);
    setErrorMessage(null);
    setIsOpenEdit(true);
  };

  const handleEditClose = () => {
    setIsOpenEdit(false);
  };

  const handleSave = (e) => {
    if (name.length > 50) {
      setErrorMessage('Category Name should not be more than 50 characters.');
      return; // Prevent closing the dialog
  }
    if(name === "" || description === ""){
      setErrorMessage("Please enter missing fields")
    }else{
      e.preventDefault();
      let data = {
        name: name,
        description: description,
      };
      axiosApiInstance.post("/category", JSON.stringify(data)).then((res) => {
        if (res.data.succeeded) {
          setOpen(false);
          setIsOpen(true);
        } else {
          setOpen(false);
          setTimeout(() => {
            setAlertMessage(res.data.message && res.data.message);
          }, 500);
        }
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setOpenUpdateMssg(false);
    }, 3000);
  }, []);     
    
  const handleUpdate = (e) => {
    if(editName === "" || editDescription === ""){
      setErrorMessageEdit("Please enter missing fields")
    }else{
      let updateData = JSON.stringify({
        id: idEdit.id,
        name: editName,
        description: editDescription,
        isActive: checked ? true : true,
      });
    
    e.preventDefault();
    axiosApiInstance.patch("/category", updateData).then((res) => {
      if (res.data.succeeded === true) {
        setIsOpenEdit(false);
        setOpenUpdateMssg(true)
      }else {
        setOpen(false);
        setTimeout(() => {
          setAlertMessage(res.data.message && res.data.message);
        }, 500);
      }
    });
  }
};
 
  const handleDelete = () => {
    axiosApiInstance
      .delete(`/category/${id}`)
      .then((res) => {
        if (res?.data?.succeeded === true) {
          setCategory(category.filter((x) => x.id !== id));
          setIsDelete(false);
          setOpenDeleteMssg(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const OnSwitchChange = (e) => {
    setChecked(e.target.checked);
    setLoading(true)
  };

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <AllTicketsHeader
        searchKeyword={searchHandler}
        term={searchTerm}
       
      />
      <SideBar />
      <div className="category-container">
          <div className="toggle-category">
            <div className="switch-category">
               <p>InActive Category</p>
            
              <Switch onChange={OnSwitchChange} checked={checked} />
            
            <p>Active Category</p>
            </div>
         
        
        <div className="add-category">
          <Button onClick={handleClickOpen}>
            <span>+</span>ADD
          </Button>
        </div>
        </div>
        <Box sx={{ width: "100%" }}>
          <Collapse in={isOpen}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              New Category added successfully!
            </Alert>
          </Collapse>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Collapse in={openDeleteMssg}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenDeleteMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Deleted successfully!
            </Alert>
          </Collapse>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Collapse in={openUpdateMssg}>
            {
              checked ?
              (
                <>
                <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenUpdateMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Updated successfully!
            </Alert>
                </>
              )
              :(
                <>
                 <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="info"
                  size="small"
                  onClick={() => {
                    setOpenUpdateMssg(false);
                  }}
                >
                  <CloseIcon fontSize="info" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              Reactived category successfully!
            </Alert>

                </>
              )
            }
             </Collapse>
        </Box>


        {
          !checked ?(<>
          {loading ? (
            <LinearProgress />
          ) : (
            <>
              <DataTable
                columns={columns}
                data={categorySearch}
                selectableRowsHighlight
                highlightOnHover
                pagination
                pointerOnHover
                paginationPerPage={perPage}
              />
            </>
          )}
          </>) 
          :
          (<>
            {loading ? (
              <LinearProgress />
            ) : (
              <>
                <DataTable
                  columns={columns}
                  data={categorySearch}
                  selectableRowsHighlight
                  highlightOnHover
                  pagination
                  pointerOnHover
                  paginationPerPage={perPage}
                />
              </>
            )}
            </>) 
        }
      
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle className="category-title">
            Create New Category
          </DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                required
                id="outlined-required"
                label="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                required
                id="outlined-textarea"
                label="Description"
                multiline
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Box>
           <Box sx={{ paddingLeft: "10px" }}> {errMessage && (
                  <label style={{ color: "red" }}>{errMessage}</label>
                )}</Box>
          </DialogContent>
          <DialogActions>
            <Button className="save-category" onClick={handleSave}>
              Save
            </Button>
            <Button className="close-category" onClick={handleClose}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isDelete}
          onClose={handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Are you sure you want to delete ? 
          </DialogTitle>
          <DialogActions>
            <Button className="save-category" onClick={handleDelete}>
              DELETE
            </Button>
            <Button className="close-category" onClick={handleDeleteClose}>
              CANCEL
            </Button>
          </DialogActions>
         
        </Dialog>
 
  <Dialog
          open={isOpenEdit}
          onClose={handleEditClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          {
      checked ? (<>
          <DialogTitle className="category-title">Update Category</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
               
                id="outlined-required"
                label="Name"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
              />
              <TextField
               
                id="outlined-textarea"
                label="Description"
                multiline
                value={editDescription}
                onChange={(e) => setEditDescription(e.target.value)}
              />
            </Box>
            <Box sx={{ paddingLeft: "10px" }}> {errMessageEdit && (
                  <label style={{ color: "red" }}>{errMessageEdit}</label>
                )}</Box>
          </DialogContent>
          <DialogActions>
            <Button className="save-category" onClick={handleUpdate}>
              SAVE
            </Button>
            <Button className="close-category" onClick={handleEditClose}>
              CANCEL
            </Button>
          </DialogActions>
          </>) : (<>
            <DialogTitle className="category-title">Do you want to re-active Category ?</DialogTitle>
          <DialogActions>
            <Button className="save-category" onClick={handleUpdate}>
              YES
            </Button>
            <Button className="close-category" onClick={handleEditClose}>
              NO
            </Button>
          </DialogActions>
          </>)
           }
        </Dialog>
      </div>
      <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />
    </>
  );
};

export default Category;
